// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"w4-z"};